import { render, staticRenderFns } from "./ModalAccessDenied.vue?vue&type=template&id=2b66f44e&"
import script from "./ModalAccessDenied.vue?vue&type=script&lang=js&"
export * from "./ModalAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports